import { render, staticRenderFns } from "./personaImmuneAgePdf.vue?vue&type=template&id=b218506a&scoped=true&"
import script from "./personaImmuneAgePdf.vue?vue&type=script&lang=js&"
export * from "./personaImmuneAgePdf.vue?vue&type=script&lang=js&"
import style0 from "./personaImmuneAgePdf.vue?vue&type=style&index=0&id=b218506a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b218506a",
  null
  
)

export default component.exports